"use client";

import {ForgotPassword} from "@/components/pages";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};
export default ForgotPasswordPage;
